import { t } from '@lingui/core/macro';
import { BooleanFilter } from './BooleanFilter';
export const postTerminationObligationsFilterLabel = () => t({
    message: 'Post termination obligations',
    comment: 'Insights: Post termination obligations filter',
});
export function PostTerminationObligationsFilter() {
    return (<BooleanFilter name="metadataDocumentPostTerminationObligations" label={postTerminationObligationsFilterLabel()}/>);
}
